import React from 'react'
import { Row, Col } from 'core/components/ui'
import styled from 'styled-components'
import SVG from 'core/components/svg'
import svg from 'assets/svg'
import { injectIntl, FormattedMessage } from 'react-intl'
import { font, greys, fontFamily } from 'assets/themes/theme-default'
import { isMobile } from 'react-device-detect'

const StyledCol = styled(Col)`
  text-align: center;
`
const Title = styled.h1`
  color: ${greys.dark1};
  font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.bold.name},`}
    ${fontFamily.bold};
  font-size: ${font.size.lgxl};
  text-align: center;
  margin: ${isMobile ? '5px 0 10px' : '25px 0 25px'};
  line-height: ${isMobile && 'normal'};
  :after {
    background: ${props => props.theme.colors.color1.bg};
    width: 25px;
    height: 5px;
    content: ' ';
    display: block;
    margin: ${isMobile ? '10px auto 25px auto' : '15px auto'};
  }
  :before {
    border-width: 0 !important;
  }
`

const Wrapper = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: ${isMobile ? '0' : '0 30px'};
  margin-bottom: 30px;
`
const TitleIconWrapper = styled.div`
  width: 45px;
  height: 45px;
  margin: 0 auto;
  background-color: ${props => props.theme.colors.color1.bg};
  border-radius: 25px;
  padding: 10px;
  margin-bottom: ${isMobile ? '5px' : '20px'};
`
const TitleIcon = styled(SVG)`
  fill: #fff;
  vertical-align: middle;
  height: 100%;
`
const Subtitle = styled.p`
  ${isMobile ? 'line-height: 19px' : null};
//   font-size: ${font.size.lg};
`

const StyledTitle = styled.h4`
  margin: 15px 0;
  font-size: ${font.size.lg};
`
const LandingPageGuide = () => (
  <Wrapper>
    <Title data-test="main-content-wrapper-title">
      <span>
        <FormattedMessage id="3_steps_tradein" />
      </span>
    </Title>
    <Row gutter={16} type="flex" align="middle">
      <StyledCol lg={8} xs={24}>
        <TitleIconWrapper>
          <TitleIcon svg={svg.calculator} data-test="title-icon-svg" />
        </TitleIconWrapper>
        <StyledTitle data-test="title-icon-title" id="globaldealer-landing-title-1">
          <FormattedMessage id="online_estimation" />
        </StyledTitle>
        <Subtitle id="globaldealer-landing-subtitle-1">
          <FormattedMessage id="online_estimation_subtitle" />
        </Subtitle>
      </StyledCol>
      <StyledCol lg={8} xs={24}>
        <TitleIconWrapper>
          <TitleIcon svg={svg.city} data-test="title-icon-svg" />
        </TitleIconWrapper>
        <StyledTitle data-test="title-icon-title" id="globaldealer-landing-title-2">
          <FormattedMessage id="salespoint_appointment" />
        </StyledTitle>
        <Subtitle id="globaldealer-landing-subtitle-2">
          <FormattedMessage id="salespoint_appointment_subtitle" />
        </Subtitle>
      </StyledCol>
      <StyledCol lg={8} xs={24}>
        <TitleIconWrapper>
          <TitleIcon svg={svg.tradein} data-test="title-icon-svg" />
        </TitleIconWrapper>
        <StyledTitle data-test="title-icon-title" id="globaldealer-landing-title-3">
          <FormattedMessage id="trade_in_offer" />
        </StyledTitle>
        <Subtitle id="globaldealer-landing-subtitle-3">
          <FormattedMessage id="trade_in_offer_subtitle" />
        </Subtitle>
      </StyledCol>
    </Row>
  </Wrapper>
)

export default injectIntl(LandingPageGuide)
